import { OtherPrice } from '@model/iceberg/deal-finder/deal-finder';
import { Amount } from '@model/common';
import React from 'react';
import styled from '@emotion/styled';
import { useI18NextContext } from '@components/hooks';
import { ThemeProps } from '@theme/base';
import { TestId } from '@components/test-ids';

const Container = styled.div(({ theme }: ThemeProps) => ({
  color: theme.custom.colors.white,
  width: '100%'
}));

const PriceRow: any = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
});

const MealPlan = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.default as any),
  marginRight: theme.custom.spacing.xLarge
}));

const Price = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.default as any),
  margin: 0,
  display: 'inline-block',
  marginRight: theme.custom.spacing.xSmall
}));

export const PerPerson = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.default as any)
}));

export interface ToolTipContentProps {
  prices: Array<OtherPrice>;
}

export const ToolTipContent = ({ prices }: ToolTipContentProps) => {
  const t: any = useI18NextContext();
  return (
    <Container data-testid={TestId.dealFinder.tile.toolTip}>
      {prices.map((price: OtherPrice) => (
        <PriceRow key={price.mealPlan}>
          <MealPlan>
            {price.mealPlan} {t('common__label--from')}
          </MealPlan>
          <div>
            <Price>{new Amount(price.perPerson.amount, price.perPerson.currency.code).format()}</Price>
            <PerPerson>{t('common__label--per-person-short')}</PerPerson>
          </div>
        </PriceRow>
      ))}
    </Container>
  );
};
